var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControl4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1600px",
    height: "1600px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16000000 16000000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".fil0 {fill:#4091CF} .fil1 {fill:white}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7999787 -59c-4418116,0 -7999799,3581943 -7999799,7999894 0,4417963 3581683,8000224 7999799,8000224 4418116,0 8000224,-3582049 8000224,-8000224 0,-4418164 -3582108,-7999894 -8000224,-7999894z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M9484635 2915470l4555372 2774281 -4514258 2749242 0 4293982c0,375579 -307276,682878 -682855,682878l-24 0c-375579,0 -682866,-307288 -682866,-682878l0 -9525465c0,-914292 735981,-650528 1324631,-292040z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 2369989,
    y: 5949995,
    width: 4180006,
    height: 979997,
    rx: 490004,
    ry: 490004
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 2369989,
    y: 10350005,
    width: 4180006,
    height: 979997,
    rx: 490004,
    ry: 490004
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    transform: "matrix(2.64845E-014 -1 1 2.64845E-014 3.96999E+006 8.53001E+006)",
    width: 4180006,
    height: 979997,
    rx: 490004,
    ry: 490004
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControl4);
export default __webpack_public_path__ + "static/media/control_4.5856dc09e4ee60184b6a4b80cad71f6d.svg";
export { ForwardRef as ReactComponent };